import { jsxs as h, jsx as l } from "react/jsx-runtime";
import { s as p, c as e, d as n, a as i } from "./themes-5f0b3c3d.mjs";
import { f as r } from "./fontWeights-a25f8f91.mjs";
import { l as a } from "./lineHeights-72d3110c.mjs";
import "react";
import { u as o } from "./index-6a632112.mjs";
const $ = o.div`
  display: flex;
  padding: ${p["4x"]};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  border: 1px dashed ${e.accentBlue[1200]};
  background: ${e.accentBlue[100]};
  ${({ height: t }) => `height:${t}`};
  ${({ width: t }) => `width:${t}`};
`, g = o.span`
  color: ${e.accentBlue[1200]};
  text-align: center;
  font-family: ${n.body};
  font-size: ${i.medium};
  font-style: normal;
  font-weight: ${r.body.semibold};
  line-height: ${a.large};
`, u = o.span`
  color: ${e.accentBlue[1200]};
  text-align: center;
  font-family: ${n.body};
  font-size: ${i.xxsmall};
  font-style: normal;
  font-weight: ${r.body.regular};
  line-height: ${a.xsmall};
`, B = ({
  title: t = "Slot",
  placeHolder: s = "This is a placeholder swap me",
  height: c = "auto",
  width: d = "auto",
  className: m,
  ...f
}) => /* @__PURE__ */ h($, { height: c, width: d, className: m, ...f, children: [
  /* @__PURE__ */ l(g, { children: t }),
  /* @__PURE__ */ l(u, { children: s })
] });
export {
  B as Slot
};
